import { ClientLayout } from "@/components/providers/ClientLayout";
import "@/app/globals.css";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return <ClientLayout>{children}</ClientLayout>;
}
